module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_fondo_negro.2a6b4b03.png";